var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcCancel({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ic-cancel",
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.482,
    height: 15.473,
    viewBox: "0 0 15.482 15.473",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_210",
    "data-name": "Path 210",
    d: "M15.084,12.884,2.952.757a1.354,1.354,0,0,0-1.915,0L.4,1.395a1.353,1.353,0,0,0,0,1.915L12.53,15.436a1.354,1.354,0,0,0,1.915,0l.638-.638a1.352,1.352,0,0,0,0-1.915Zm0,0",
    transform: "translate(0 -0.36)",
    fill: "#f44336"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_211",
    "data-name": "Path 211",
    d: "M12.53.758.4,12.885A1.353,1.353,0,0,0,.4,14.8l.638.638a1.355,1.355,0,0,0,1.916,0L15.085,3.312a1.352,1.352,0,0,0,0-1.914L14.446.759a1.355,1.355,0,0,0-1.916,0Zm0,0",
    transform: "translate(0 -0.361)",
    fill: "#f44336"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCancel);
export default __webpack_public_path__ + "static/media/ic-cancel.4e77e34ad535a5d606d8799d782e462a.svg";
export { ForwardRef as ReactComponent };